import type { ChainId, MarketId } from '@morpho-org/blue-sdk';
import { memo } from 'react';
import { useAutoDeleverage } from '../hooks/useAutoDeleverage';
import { useIsAutoDeleverageEnabled } from '../hooks/useIsAutoDeleverageEnabled';
interface ProtectedLltvLabelProps {
  marketId: MarketId;
  chainId: ChainId;
  label?: string;
  defaultLabel?: string;
}
const ProtectedLltvLabel = t0 => {
  const {
    marketId,
    chainId,
    label: t1,
    defaultLabel: t2
  } = t0;
  const label = t1 === undefined ? "LTV / Auto-Delev. LTV" : t1;
  const defaultLabel = t2 === undefined ? "LTV / Liq. LTV" : t2;
  const isAutoDeleverageEnabled = useIsAutoDeleverageEnabled(chainId);
  const {
    status: autoDeleverageStatus
  } = useAutoDeleverage(marketId, chainId);
  if (isAutoDeleverageEnabled && autoDeleverageStatus === "authorized") {
    return label;
  }
  return defaultLabel;
};
export default memo(ProtectedLltvLabel);